module.exports = __webpack_public_path__ + "img/file_icon.ace7883c.svg";